<template>
  <div class="container h-100 d-flex flex-column">
    <div class="header">
        <slot name="header" />
    </div>

    <div class="content overflow-hidden flex-grow-1 d-flex">
        <slot />
    </div>

    <div class="footer">
        <slot name="footer" />
    </div>
  </div>
</template>

<style scoped lang="less">
.container {
  max-height: 100%;
}
.content:deep(> div),
.content:deep(> section) {
  overflow: auto;
  scrollbar-width: thin;
}
</style>
